import { formatDate } from '../../core/utils'

const formatCreatedByText = (createdAt, createdByName) =>
  `${formatDate(createdAt)} by ${createdByName}`

export default formatCreatedByText
